module.exports = __webpack_public_path__ + "media/images/emblems/Sauge-coat_of_arms-da34f90d5a8f2ea09578b67138c2acf7.svg";